export default {
      id: "insurance-usage",
      viewBox: "0 0 22 24.376",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#insurance",
      toString: function () {
        return this.url;
      }
    }